import { render } from "./LessonCardSmall.vue?vue&type=template&id=25580c38&scoped=true"
import script from "./LessonCardSmall.vue?vue&type=script&lang=js"
export * from "./LessonCardSmall.vue?vue&type=script&lang=js"

import "./LessonCardSmall.vue?vue&type=style&index=0&id=25580c38&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25580c38"]])

export default __exports__